module.exports = __webpack_public_path__ + "static/media/5.b874480a.JPG";